export default __webpack_public_path__ + "static/media/rescale_nda.7b01b709.pdf";